import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./CSS/HeroSection.css";

import PinkHeader from "../SHOPE/Header";
import { API_BASE, FILE_BASE } from "../config";

export default function Hero() {
  const navigate = useNavigate();

  const [slides, setSlides] = useState([]);
  const [index, setIndex] = useState(0);

  // Fetch Hero Banners from Backend
  useEffect(() => {
    fetch(`${API_BASE}/HeroBanner`)
      .then((res) => res.json())
      .then((data) => {
        const mappedSlides = data.map((item) => ({
          img: FILE_BASE + item.imageUrl,
          title: item.title,
          desc: item.description,
          cards:
            item.cards?.map((card) => ({
              img: FILE_BASE + card.imageUrl,
              title: card.title,
              desc: card.description,
            })) || [],
        }));

        setSlides(mappedSlides);
      })
      .catch((err) => {
        console.error("Error fetching hero banners:", err);
      });
  }, []);

  // Auto Slider
  useEffect(() => {
    if (slides.length === 0) return;

    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [slides]);

  if (slides.length === 0) {
    return (
      <section className="hero">
        <PinkHeader />
        <div className="hero-loading">
          <h2>Loading...</h2>
        </div>
      </section>
    );
  }

  return (
    <section className="hero">
      {/* Background Image */}
      <img
        key={index}
        src={slides[index]?.img}
        alt={`Hero ${index + 1}`}
        className="hero-bg"
      />

      {/* Header */}
      <PinkHeader />

      {/* Hero Content */}
      <div key={index} className="hero-content">
        <h1>{slides[index]?.title}</h1>
        <p>{slides[index]?.desc}</p>

        <div className="buttons">
          <button
            className="btn primary"
            onClick={() => {
              const section = document.getElementById("shop-occasion");
              section?.scrollIntoView({ behavior: "smooth" });
            }}
          >
            Shop New Arrivals
          </button>
        </div>
      </div>

      {/* Cards */}
      <div className="card-stack">
        <div className="card back-card-2">
          {slides[index]?.cards?.[2] && (
            <img
              src={slides[index].cards[2].img}
              alt={slides[index].cards[2].title}
            />
          )}
        </div>

        <div className="card back-card-1">
          {slides[index]?.cards?.[1] && (
            <img
              src={slides[index].cards[1].img}
              alt={slides[index].cards[1].title}
            />
          )}
        </div>

        <div className="card main-card">
          {slides[index]?.cards?.[0] && (
            <>
              <img
                src={slides[index].cards[0].img}
                alt={slides[index].cards[0].title}
              />

              <div className="card-text">
                <h4>{slides[index].cards[0].title}</h4>
                <p>{slides[index].cards[0].desc}</p>

                <button className="secondary" onClick={() => navigate("/shop")}>
                  Explore Collections
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
}
